export class SoundConstants {
    static readonly BASE_MUSIC = 'base_music_loop';
    static readonly FREEGAME_MUSIC = 'free_background_loop';
    static readonly INTRO_MUSIC = 'Intro_transition';
    static readonly REELS_SPIN = 'reels_spinning';
    static readonly REEL_STOP = 'reel_stop';
    static readonly SCATTER_TRIGGER = 'Scatter_Trigger';
    static readonly SCATTER_LAND = 'scatter_land';
    static readonly BUTTON_CLICK = 'click';
    static readonly BET_LEVEL = "bet-level";
    static readonly TOTAL_WIN = "total_win";
    static readonly ANTICIPATION_LOOP = "scatter_anticipation_loop";
    static readonly SYMBOL_WIN = "symbol_win";
    static readonly BIG_WIN_LOOP = "win_loop";
    static readonly WIN_TICKUP = "win_tickup";
    static readonly WIN_TICKUP_END = "win_tickup_end";
    static readonly FEATURE_BANNER = "free_Game_Banner";
    static readonly BIG_WIN = "Big_Win_Transition";
    static readonly MEGA_WIN = "Mega_Win_Transition";
    static readonly SUPER_WIN = "Super_Win_Transition";
    static readonly EPIC_WIN = "Epic_Win_Transition";
    static readonly JACKPOT_UPGRADED = "jackpot_upgraded";
    static readonly JACKPOT_UPDATE = "jackpot_update";
    static readonly SCARAB_FIRE = "scarab_symbol_firing";
    static readonly STONE_TRANSITION = "stones_transition";
    static readonly METER_HIT_BASEMETER = "collectXtoWinX_message";
    static readonly REEL_EXTAND = "framework_expanding";
    static readonly SCATTER_LANDING = "scatter_landing";
}